import { application } from "./application"

import MenuController from "./menu_controller"
import PriceController from "./price_controller"
import VariationsController from "./variations_controller"
import CopyController from "./copy_controller"
import PhotoPreviewController from "./photo_preview_controller"
import ToastController from "./toast_controller"
import OrderItemController from "./order_item_controller"

application.register("menu", MenuController)
application.register("price", PriceController)
application.register("variations", VariationsController)
application.register("copy", CopyController)
application.register("photo-preview", PhotoPreviewController)
application.register("toast", ToastController)
application.register("order-item", OrderItemController)
